import React from "react";
import ReactDOM from "react-dom";
import SearchBar from "./WholePageSearchBar";

import "./css/Header.css";
// import TrodlyLogo from './images/trodlyLogo.svg';
import SearchIcon from "./images/searchIcon.svg";
// import SearchSuggestions from './SearchSuggestions';
import LoadingSvg from "./images/loading.svg";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activities: [],
      loading: false
    };
  }
  closeSearchBar = () => {
    ReactDOM.unmountComponentAtNode(document.getElementById("searchBar"));
    document.body.style.overflow = "auto";
  };
  activateSearchBar = () => {
    ReactDOM.render(
      <SearchBar closeSearchBar={this.closeSearchBar} />,
      document.getElementById("searchBar")
    );
    document.body.style.overflow = "hidden";
  };
  render() {
    var logoPlaceholder;
    if (this.props.affiliateLogo) {
      logoPlaceholder = (
        <img
          src={this.props.affiliateLogo}
          style={{ width: "100%", display: "block", height: "100%" }}
          alt="Affiliate Logo"
        />
      );
    } else {
      logoPlaceholder = (
        <div className="affiliate-logo-placeholder">
          <span />
          <span />
          <span />
        </div>
      );
    }
    return (
      <header
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
      >
        <div
          className="affiliateLogo"
          style={{ marginRight: 10, width: "8rem" }}
        >
          {logoPlaceholder}
        </div>
        {this.props.affiliateName !== "Trodly" && (
          <div className="poweredBy">
            <div className="poweredByText">
              <span style={{ color: "#ffffff", fontSize: "0.8rem" }}>
                {" "}
                / Experiences by
              </span>
            </div>
            <div className="trodlyLogo">
              {/*<img src={TrodlyLogo} style={{height:'100%',display:'block'}} alt="Trodly Logo"/>*/}
              <svg
                version="1.1"
                x="0px"
                y="0px"
                width="118px"
                height="48px"
                viewBox="0 0 118 48"
                enableBackground="new 0 0 118 48"
              >
                <g>
                  <rect
                    fill="#ffffff"
                    fillOpacity="0"
                    width="118"
                    height="48"
                  />
                  <g>
                    <path
                      fill="#ffffff"
                      d="M34.704,23.465c0,3.779-3.068,6.853-6.851,6.853c-3.781,0-6.85-3.073-6.85-6.853
										c0-3.784,3.069-6.844,6.85-6.844C31.636,16.621,34.704,19.681,34.704,23.465z M27.854,20.598c-1.585,0-2.866,1.287-2.866,2.867
										c0,1.586,1.281,2.862,2.866,2.862c1.583,0,2.865-1.276,2.865-2.862C30.719,21.885,29.437,20.598,27.854,20.598z"
                    />
                    <g>
                      <path
                        fill="#ffffff"
                        d="M60.254,17.241c0.204,0.204,0.309,0.456,0.309,0.76c0,0.289-0.107,0.549-0.317,0.759
											c-0.215,0.21-0.461,0.312-0.742,0.312h-2.44v10.32c0,0.29-0.104,0.54-0.311,0.746c-0.205,0.213-0.458,0.319-0.754,0.319
											c-0.295,0-0.546-0.106-0.75-0.319c-0.209-0.206-0.311-0.456-0.311-0.746v-10.32h-2.42c-0.3,0-0.549-0.103-0.755-0.312
											c-0.203-0.21-0.308-0.47-0.308-0.759c0-0.304,0.104-0.556,0.308-0.76c0.206-0.204,0.456-0.304,0.755-0.304h6.987
											C59.798,16.938,60.048,17.037,60.254,17.241z"
                      />
                      <path
                        fill="#ffffff"
                        d="M63.914,21.951c0.297-0.349,0.703-0.618,1.214-0.83c0.519-0.219,0.987-0.326,1.412-0.322
											c0.422,0.012,0.739,0.109,0.934,0.312c0.203,0.188,0.302,0.425,0.302,0.704c0,0.271-0.099,0.512-0.302,0.712
											c-0.195,0.22-0.447,0.253-0.721,0.323c-1.424,0.322-2.839,1.25-2.839,2.908v3.672c0,0.279-0.103,0.521-0.308,0.723
											c-0.208,0.199-0.454,0.306-0.745,0.306c-0.29,0-0.532-0.106-0.732-0.306c-0.2-0.201-0.3-0.443-0.3-0.723v-7.605
											c0-0.284,0.1-0.526,0.3-0.714c0.2-0.202,0.442-0.298,0.732-0.298c0.292,0,0.538,0.096,0.745,0.298
											c0.205,0.188,0.308,0.43,0.308,0.714V21.951z"
                      />
                      <path
                        fill="#ffffff"
                        d="M73.226,30.507c-1.3,0-2.402-0.48-3.301-1.423c-0.902-0.955-1.354-2.091-1.354-3.421
											c0-1.318,0.454-2.463,1.363-3.425c0.907-0.967,1.995-1.446,3.273-1.446c1.273,0,2.359,0.486,3.251,1.468
											c0.896,0.96,1.341,2.115,1.341,3.468c0,1.33-0.448,2.435-1.348,3.315C75.598,30.014,74.524,30.507,73.226,30.507z M71.374,23.638
											c-0.463,0.535-0.696,1.204-0.696,2.001s0.232,1.486,0.696,2.057c0.501,0.467,1.104,0.702,1.813,0.702
											c0.708,0,1.312-0.235,1.818-0.702c0.498-0.57,0.752-1.26,0.752-2.057s-0.254-1.466-0.752-2.001
											c-0.559-0.49-1.158-0.736-1.818-0.736C72.531,22.901,71.926,23.147,71.374,23.638z"
                      />
                      <path
                        fill="#ffffff"
                        d="M88.958,29.415c0,0.272-0.099,0.518-0.303,0.724c-0.21,0.213-0.446,0.319-0.719,0.319
											c-0.267,0-0.496-0.094-0.685-0.243c-0.188-0.17-0.306-0.36-0.36-0.591c-0.808,0.55-1.682,0.834-2.622,0.834
											c-1.304,0-2.404-0.475-3.322-1.425c-0.913-0.949-1.372-2.079-1.372-3.406c0-1.312,0.459-2.444,1.372-3.399
											c0.918-0.958,2.019-1.436,3.322-1.436c0.952,0,1.814,0.276,2.586,0.811v-3.619c0-0.294,0.102-0.538,0.31-0.742
											c0.206-0.204,0.456-0.304,0.743-0.304c0.29,0,0.535,0.1,0.746,0.304c0.204,0.204,0.303,0.448,0.303,0.742V29.415z M84.269,28.348
											c0.71,0,1.318-0.271,1.824-0.798c0.507-0.54,0.763-1.175,0.763-1.923c0-0.73-0.252-1.381-0.753-1.92
											c-0.498-0.53-1.114-0.806-1.833-0.806c-0.721,0-1.332,0.275-1.833,0.806c-0.503,0.539-0.752,1.189-0.752,1.92
											c0,0.748,0.25,1.383,0.76,1.923C82.952,28.076,83.561,28.348,84.269,28.348z"
                      />
                      <path
                        fill="#ffffff"
                        d="M92.226,18.001c0-0.304,0.099-0.556,0.305-0.76c0.208-0.204,0.458-0.304,0.755-0.304
											c0.296,0,0.553,0.1,0.759,0.304c0.215,0.204,0.322,0.456,0.322,0.76v11.392c0,0.29-0.107,0.54-0.322,0.746
											c-0.206,0.213-0.463,0.319-0.759,0.319c-0.297,0-0.548-0.106-0.755-0.319c-0.206-0.206-0.305-0.456-0.305-0.746V18.001z"
                      />
                      <path
                        fill="#ffffff"
                        d="M103.386,21.087c0.192-0.186,0.43-0.295,0.714-0.295c0.282,0,0.527,0.11,0.73,0.306
											c0.209,0.197,0.312,0.442,0.312,0.727v7.292c0,1.289-0.45,2.387-1.343,3.279c-0.895,0.889-1.986,1.337-3.271,1.337
											c-0.684,0-1.349-0.154-1.993-0.487c-0.267-0.114-0.448-0.3-0.538-0.567c-0.093-0.252-0.079-0.527,0.039-0.802
											c0.131-0.232,0.328-0.382,0.606-0.483c0.279-0.085,0.57-0.051,0.881,0.104c0.307,0.146,0.694,0.23,1.158,0.224
											c0.463-0.007,0.915-0.181,1.358-0.507c0.447-0.324,0.743-0.747,0.898-1.243c-0.54,0.304-1.149,0.463-1.829,0.463
											c-1.109,0-2.062-0.407-2.853-1.201c-0.787-0.8-1.187-1.757-1.187-2.854v-4.554c0-0.284,0.099-0.529,0.298-0.727
											c0.202-0.195,0.443-0.306,0.729-0.306c0.282,0,0.52,0.109,0.711,0.295c0.191,0.189,0.29,0.438,0.29,0.737v4.554
											c0,0.55,0.195,1.019,0.584,1.401c0.395,0.383,0.869,0.568,1.427,0.568c0.55,0,1.02-0.186,1.404-0.568
											c0.389-0.383,0.581-0.852,0.581-1.401v-4.554C103.093,21.524,103.192,21.276,103.386,21.087z"
                      />
                    </g>
                    <path
                      fill="#ffffff"
                      d="M42.328,33.747c0,2.313-1.883,4.195-4.195,4.195H17.576c-2.312,0-4.193-1.882-4.193-4.195v-20.56
										c0-2.311,1.88-4.188,4.193-4.188h20.557c2.312,0,4.195,1.877,4.195,4.188V33.747z M40.646,13.758c0-1.623-1.313-2.944-2.935-2.944
										H18.139c-1.623,0-2.937,1.321-2.937,2.944v19.571c0,1.623,1.314,2.927,2.937,2.927h19.572c1.622,0,2.935-1.304,2.935-2.927V13.758
										z"
                    />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        )}
        <div className="trodly-search" onClick={this.activateSearchBar}>
          <div
            className="searchIcon"
            style={{ height: "50%", marginRight: "0.5rem" }}
          >
            <img
              src={this.state.loading ? LoadingSvg : SearchIcon}
              style={{ display: "block", height: "100%" }}
              alt=""
            />
          </div>
          <div
            className="searchInput"
            style={{ height: "100%", width: "100%" }}
          >
            <input
              type="text"
              style={{
                backgroundColor: "transparent",
                height: "100%",
                width: "100%",
                border: "none",
                fontSize: "1rem",
                outline: "none",
                cursor: "pointer"
              }}
              aria-label="Search Trodly.com for more activities"
              placeholder="Search"
              disabled={true}
            />
          </div>
        </div>
        <div className="searchIconForMobile" onClick={this.activateSearchBar}>
          <img src={SearchIcon} alt="" style={{ height: "60%" }} />
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.jsx